import angular from 'angular';
import { AuthApi } from "../../../api/Api";
import Login from "../../../page/login/Login";
import UriUtils from "../../../utils/UriUtils";
import helper from "../../helper";


var checkEmailAvailability = function(email, $q, checkEmailFunction, appServices) {

    if(email) {
        // as we use ui-validate, we can't resolve the promise using serviceCall function. Ui-validate has to do it.
        var deferred = $q.defer();
        appServices.loading();
        checkEmailFunction(
            {email : email.toLowerCase()},
            function(response) {
                appServices.ready();
                if(response.alreadyExist) { // if already exist, then not available...
                    deferred.reject(false);
                } else {
                    deferred.resolve(true);
                }
            },
            function() {
                deferred.reject(false);
            }
        );
        return deferred.promise;
    } else return true;
};

var MainCtrl = function($scope, $location) {
    // Display "go back" link only when current page is 'create'
    $scope.displayGoBackLink = $location.absUrl().indexOf('create') !== -1 || $location.absUrl().indexOf('lostpassword') !== -1;
    let $logos = $("#brand-logos-mobile .p-link");
    let logoVisibleClass = "p-link--visible";

    function switchLogo() {
        $logos.each( (i, logo) => {
            if($(logo).hasClass(logoVisibleClass)) {
                $(logo).removeClass(logoVisibleClass);
                let nextLogo = $logos.get(i + 1) || $logos.get(0);
                $(nextLogo).addClass(logoVisibleClass);

                return false;
            }
        });
    }


    setInterval(switchLogo, 3000);
};

var AlertBoxCtrl = function($scope, userServices, appServices) {

    $scope.resendValidationEmail = function() {
            appServices.loading();
            userServices.resendValidationEmail(
                {},
                function(){
                    appServices.ready();
                },
                function(){
                    appServices.ready();
                }
            )
    };

    $scope.isLoading = function() {
        return !appServices.isReady();
    };
    appServices.ready();
};

var UserProfileEditCtrl = function($scope, $q, userServices, appServices) {
    $scope.emailPattern = helper.patterns().email;
    $scope.namePattern = helper.patterns().name;
    $scope.passwordMinLength = helper.getPasswordMinLength();

    var getErrors = function(e) {
        var errors = [];
        if(e.data.error) {
            angular.forEach(e.data.error, function(v){
                this.push(v[0].msg);
            }, errors);
        }
        return errors;
    };

    $scope.updateContact = function() {
        appServices.loading();
        userServices.updateDetails(
            $scope.editedContact,
            function(){
                angular.copy($scope.editedContact, $scope.user.contactDetails);
                appServices.ready();
            },
            function(){ //Todo: manage errors
                angular.copy($scope.user.contactDetails, $scope.editedContact)
                appServices.ready();
            }
        );
        $scope.onEditContact = false;
    };

    $scope.cancelEditContact = function() {
        angular.copy($scope.user.contactDetails, $scope.editedContact)
        $scope.onEditContact = false;
    };

    $scope.checkEmailAvailability = function(email) {
        return checkEmailAvailability(email, $q, userServices.checkForEmailUpdate, appServices)
    };

    $scope.updateEmail = function() {

        if($scope.user.email !== $scope.editedEmail) {
            appServices.loading();
            userServices.changeEmail(
                {newEmail:$scope.editedEmail},
                function(){
                    $scope.user.email = $scope.editedEmail;
                    $scope.user.isEmailValid = false;
                    appServices.ready();
                },
                function(){ //Todo: manage errors
                    $scope.editedEmail = $scope.user.email;
                    appServices.ready();
                }
            );
        }
        $scope.onEditEmail = false;
    };

    $scope.cancelEditEmail = function() {
        $scope.editedEmail = $scope.user.email;
        $scope.onEditEmail = false;
    };

    $scope.updatePassword = function() {
        appServices.loading();
        userServices.changePassword(
            {oldPassword: $scope.oldPassword, newPassword: $scope.newPassword},
            function(){
                appServices.ready();
                $scope.oldPassword = "";
                $scope.newPassword = "";
                $scope.newPasswordConfirmation = "";
                $scope.updatePasswordError = undefined;
                $scope.updatePasswordOk = true;
                $scope.onEditPassword = false;
            },
            function(e){
                appServices.ready();
                $scope.updatePasswordError = getErrors(e);
            }
        );
    };

    $scope.cancelEditPassword = function() {
        $scope.oldPassword = "";
        $scope.newPassword = "";
        $scope.newPasswordConfirmation = "";
        $scope.updatePasswordError = undefined;
        $scope.updatePasswordOk = false;
        $scope.onEditPassword = false;
    }

};


var UserCreateCtrl = function($scope, $q, userServices, appServices) {
    $scope.emailPattern = helper.patterns().email;
    $scope.namePattern = helper.patterns().name;
    $scope.passwordMinLength = helper.getPasswordMinLength();
    $scope.user = {};
    /* eslint-disable camelcase */
    let uriUtils = new UriUtils(window.location.search);
    $scope.apiVersion = uriUtils.getQueryParam("apiVersion");
    $scope.client_id = '';
    $scope.state = '';
    /* eslint-disable camelcase */
    $scope.redirect_uri = '';
    $scope.creatingProfile = false;
    $scope.createUserError = false;
    var defaultNewUser = {
        isDisabled:false,
        isEmailValid:false,
        contactDetails:{
            preferredLanguage:'de',
            gender: 'm'
        }
    };


    angular.copy(defaultNewUser, $scope.user);

    $scope.create = function(newUser) {
        $scope.creatingProfile = true;
        appServices.loading();

        userServices.save(
            ($scope.client_id && $scope.redirect_uri) ? {client_id:$scope.client_id, redirect_uri:$scope.redirect_uri, apiVersion:$scope.apiVersion} : {},
            newUser,
            function(response){
                appServices.ready();

                if(response.code){
                    window.location.href = $scope.redirect_uri + "?code=" + response.code + "&state=" + $scope.state; // to oauth redirect is state is defined
                } else {
                    if($scope.redirect_uri) {
                        window.location.href = $scope.redirect_uri;
                    } else {
                        window.location.href = "/";
                    }
                }
                //$scope.creatingProfile = false;
            },
            function(response){ //Todo: manage errors
                if(response.status !== 200) { // TODO : which error codes to check
                    if(response.data.code === 190) {
                        //User created but initial login session has expired
                        window.location.href = "/"; //TODO not sure that this is the best, but we cannot do anything else. User was created.
                    } else {
                        $scope.creatingProfile = false;
                        $scope.createUserError = true;
                        $scope.emailAlreadyExists = response.data.error['obj.email'] && response.data.error['obj.email'][0].msg[0].indexOf("alreadyExist")!== -1
                    }
                }
                appServices.ready();
            }
        );
    };

    $scope.emailErrorClass = function() {
        return $scope.emailAlreadyExists ? 'ng-invalid ng-dirty' : '';
    };

    $scope.checkEmailAvailability = function(email) {
        return checkEmailAvailability(email, $q, userServices.checkEmail, appServices)
    };

    $scope.isLoading = function() {
        return !appServices.isReady();
    };

    appServices.ready();
    $scope.formReady = true;
};

var ResetPasswordCtrl = function($scope, $q, userServices, appServices){
    $scope.passwordMinLength = helper.getPasswordMinLength();
    $scope.token = "";
    $scope.newPassword = "";
    $scope.confirmPassword = "";

    $scope.setToken = function(token){
        $scope.token = token;
    };

    $scope.isLoading = function() {
        return !appServices.isReady();
    };

    $scope.isReady = function() {
        return appServices.isReady();
    };

    $scope.resetPassword = function(){
        appServices.loading();
        userServices.resetPassword(
            {t:$scope.token},
            {newPassword:$scope.newPassword, confirmPassword: $scope.confirmPassword},
            function(){
                window.location.replace("/");
                appServices.ready();
            },
            function(){
                // todo: manage errors
                appServices.ready();
            }
        )
    };

    appServices.ready();
    $scope.formReady = true;
};

var LoginCtrl = function($scope){
    $scope.expendText = function(){
        $(".home-desc-container").toggleClass("home-expend");
        var $slider = $(".home-desc-container");

        if ( $( ".home-desc-container" ).hasClass( "home-expend" ) ) {
            $slider.css("max-height", $($slider.children()[0]).height());
            $(".read-more").removeClass("bg-gradient");
            $( ".initial-chevron ").removeClass("fa-chevron-down").addClass("fa-chevron-up");
        } else {
            $slider.css("max-height", '');
            $(".read-more").addClass("bg-gradient");
            $( ".initial-chevron ").removeClass("fa-chevron-up").addClass("fa-chevron-down");
        }
    };

    $scope.showPassword = false;
    
    $scope.login = function () {
        let uri = AuthApi.loginUri;
        let data = {
            email: $scope.email,
            password: $scope.password
        };

        ssoLogin(uri, data);
    };

    $scope.oauthLogin = function (apiVersion) {
        let uriUtils = new UriUtils(window.location.search);
        let uri = AuthApi.oauthLoginUri(uriUtils.getQueryParam("lang"), apiVersion);
        let data = {
            email: $scope.email,
            password: $scope.password,
            apiVersion: uriUtils.getQueryParam("apiVersion"),
            clientId: uriUtils.getQueryParam("client_id"),
            redirectUri: uriUtils.getQueryParam("redirect_uri"),
            state: uriUtils.getQueryParam("state"),
            ...($scope.loginCode ? {loginCode: $scope.loginCode} : {})
        };
        

        ssoLogin(uri, data);
    };

    let ssoLogin = function (url, data) {
        $.ajax({
            type: 'POST',
            url: url,
            contentType: 'application/json',
            dataType: 'json',
            data: JSON.stringify(data)
        })
        .done(Login.redirectAfterLogin)
        .fail(Login.showErrorMessage);
    }
};

MainCtrl.$inject = ['$scope', '$location'];
AlertBoxCtrl.$inject = ['$scope', 'userServices', 'appServices'];
UserProfileEditCtrl.$inject = ['$scope', '$q', 'userServices', 'appServices'];
UserCreateCtrl.$inject = ['$scope', '$q', 'userServices', 'appServices'];
ResetPasswordCtrl.$inject = [ '$scope', '$q', 'userServices', 'appServices'];
LoginCtrl.$inject = [ '$scope'];

export default {
  MainCtrl: MainCtrl,
  AlertBoxCtrl: AlertBoxCtrl,
  UserProfileEditCtrl: UserProfileEditCtrl,
  UserCreateCtrl: UserCreateCtrl,
  ResetPasswordCtrl: ResetPasswordCtrl,
  LoginCtrl: LoginCtrl
}


// WEBPACK FOOTER //
// ./js/legacy/app/user/controllers.js